const targetVariantId = window.customDesginTargetVariantID;

setupCustomCartDrawerUpdate({
  checkFn: (cart) => {
    return cart.items.some((item) => item.variant_id === targetVariantId);
  },
  onMatch: (cart) => {
    const drawer = document.querySelector(".cart-drawer");

    const productRow = Array.from(
      drawer.querySelectorAll(".cart-products")
    ).find((row) => {
      return row.querySelector(
        `.cart__item[data-product-variant-id="${targetVariantId}"]`
      );
    });

    const item = cart.items.find((item) => item.variant_id === targetVariantId);

    if (productRow && item) {
      const mediaWrapper = productRow.querySelector("a.media-wrapper");
      if (mediaWrapper) {
        // Check if the image already exists
        const existingImg = mediaWrapper.querySelector("img.custom-design-img");
        if (!existingImg) {
          const img = document.createElement("img");
          img.src = item.properties["Custom Product Design Front"];
          img.width = 300;
          img.alt = item.title;
          img.classList.add("custom-design-img");

          // Remove placeholder SVG if it exists
          const svg = mediaWrapper.querySelector("svg");
          if (svg) svg.remove();

          mediaWrapper.appendChild(img);
        }
      }
    }
  },
  delay: 500,
  drawerSelector: ".cart-drawer",
});

function setupCustomCartDrawerUpdate({
  checkFn,
  onMatch,
  delay = 500,
  drawerSelector = ".cart-drawer",
}) {
  const debounce = (callback, delay) => {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => callback.apply(this, args), delay);
    };
  };

  const fetchAndHandleCart = async () => {
    try {
      const res = await fetch("/cart.js");
      const cart = await res.json();

      if (checkFn(cart)) {
        onMatch(cart);
      }
    } catch (err) {
      console.error("Error fetching cart:", err);
    }
  };

  const debouncedUpdate = debounce(fetchAndHandleCart, delay);

  const drawer = document.querySelector(drawerSelector);
  if (!drawer) {
    console.warn("Cart drawer element not found.");
    return;
  }

  const observer = new MutationObserver(debouncedUpdate);
  observer.observe(drawer, { childList: true, subtree: true });

  // Initial check
  fetchAndHandleCart();
}



// Bundle removal: when suit is removed, remove all linked addons too
(function() {
  var _bundleRemoving = false;

  document.addEventListener('click', function(e) {
    if (_bundleRemoving) return;

    var removeBtn = e.target.closest('.js-cart-product-remove');
    if (!removeBtn) return;

    var row = removeBtn.closest('.cart__item');
    if (!row) return;

    // Only act on suit rows (not addons — they have no delete button anyway)
    var isAddon = row.dataset.isAddon === 'true';
    if (isAddon) return;

    var groupId = row.dataset.group;
    if (!groupId || groupId === '') return; // no group, let theme handle normally

    var itemKey = row.dataset.key;
    if (!itemKey) return;

    // We have a grouped suit — stop everything and handle ourselves
    e.stopImmediatePropagation();
    e.preventDefault();

    _bundleRemoving = true;

    // Find all addon rows in the DOM with the same group ID
    var addonRows = document.querySelectorAll('[data-group="' + groupId + '"][data-is-addon="true"]');
    var updates = {};
    addonRows.forEach(function(r) {
      if (r.dataset.key) updates[r.dataset.key] = 0;
    });

    function removeSuit() {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: itemKey, quantity: 0 })
      }).then(function() {
        _bundleRemoving = false;
        if (window.theme && theme.ajaxCart) {
          theme.ajaxCart.update();
        } else {
          window.location.reload();
        }
      }).catch(function() {
        _bundleRemoving = false;
        window.location.reload();
      });
    }

    if (Object.keys(updates).length === 0) {
      // No addons in DOM — just remove the suit
      removeSuit();
      return;
    }

    // Remove all addons first, then remove suit
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function() {
      removeSuit();
    }).catch(function() {
      removeSuit();
    });

  }, true); // capture phase — fires before the theme's listener

})();